import { LogoutLocalActionTypes } from './types';
import { action } from 'typesafe-actions';

export const logoutStart = () => action(LogoutLocalActionTypes.LOGOUT_START);
export const logoutSuccess = () =>
  action(LogoutLocalActionTypes.LOGOUT_SUCCESS);
export const logoutFailure = (error: string) =>
  action(LogoutLocalActionTypes.LOGOUT_FAILURE, error);
